import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var BellPlus = createReactComponent("BellPlus", ["svg", defaultAttributes, [["path", {
  d: "M18.387 12C19.198 15.799 21 17 21 17H3s3-2 3-9a6 6 0 017-5.916",
  key: "fun4fk"
}], ["path", {
  d: "M13.73 21a2 2 0 01-3.46 0",
  key: "41ys2d"
}], ["path", {
  d: "M18 2v6",
  key: "191g95"
}], ["path", {
  d: "M21 5h-6",
  key: "15uff2"
}]]]);
export default BellPlus;